import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../../lib/api";
import { reveal, revealContainer, viewportOnce, scrollToId } from "../../lib/motion";

export const Menu = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/menu").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="menu" data-testid="menu-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <span className="label-caps text-sage">Popular Menu</span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.05]">
            Signature dishes, <span className="italic text-gold">crafted daily</span>
          </h2>
        </div>

        <motion.div
          variants={revealContainer}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
        >
          {items.map((it, i) => (
            <motion.article
              key={it.id}
              variants={reveal}
              data-testid={`menu-card-${i}`}
              className="group"
            >
              <div className="relative overflow-hidden aspect-[4/5] bg-surface mb-5">
                <img
                  src={it.image}
                  alt={it.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <div className="absolute top-4 right-4 bg-cream/90 backdrop-blur px-4 py-1.5 font-serif text-lg text-charcoal">
                  {it.price}
                </div>
              </div>
              <h3 className="font-serif text-2xl text-ink">{it.name}</h3>
              <p className="mt-2 text-ink/60 leading-relaxed text-sm">
                {it.description}
              </p>
            </motion.article>
          ))}
        </motion.div>

        <div className="mt-16 flex justify-center">
          <button
            data-testid="menu-full-btn"
            onClick={() => scrollToId("full-menu")}
            className="rounded-full border border-charcoal px-8 py-3.5 text-charcoal hover:bg-charcoal hover:text-cream transition-colors duration-300"
          >
            View Full Catering Menu
          </button>
        </div>
      </div>
    </section>
  );
};
